import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import { CredentialFragment, CREDENTIAL_FRAGMENT } from "../../fragments";
import { UserLoginMutationVariables } from "../../types";

export const USER_LOGIN = gql`
  mutation userLogin($email: String!, $password: String!) {
    userLogin(email: $email, password: $password) {
      credentials {
        ...CredentialFragment
      }
    }
  }
  ${CREDENTIAL_FRAGMENT}
`;

export type UserLoginData = { userLogin: { credentials: CredentialFragment } };

export default (
  options?: MutationHookOptions<UserLoginData, UserLoginMutationVariables>
) => {
  return useMutation<UserLoginData, UserLoginMutationVariables>(
    USER_LOGIN,
    options
  );
};
